import { gql } from "apollo-boost"

export const GET_SUBMISSION_ALLIES = gql`
  query getSubmissionAllies($id: ID!) {
    Submission: SubmissionDetails(id: $id) {
      id
      state
      name
      alliedOne
      alliedTwo
      endDate
      startDate
      region
    }
  }
`